import { render, staticRenderFns } from "./Atributos.vue?vue&type=template&id=ac0999d6"
import script from "./Atributos.vue?vue&type=script&lang=js"
export * from "./Atributos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports